import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';


class TeamService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.TEAM = '/api/team';

        this.GET_BY_ID = '/{id}';
        this.GET_LIST_BY_ORG = '/list/org/{orgId}';
        this.GET_LIST_BY_USER = '/list/user/{userId}';
        this.GET_USER_LIST_BY_TEAM = '/list/user/team/{teamId}';
        this.SEARCH_TEAM_BY_KEYWORD = '/search/keyword';
        this.SEARCH_TEAM_BY_KEYWORD_FOR_USER = '/search/keyword/{keyword}/user';

        this.ADD_CONTRIBUTOR = '/add/contributor';
        this.UPDATE_CONTRIBUTOR = '/update/contributor';
        this.REMOVE_CONTRIBUTOR = '/remove/contributor';

    }

    /**
     * This class manages the REST Protocols for Teams.
     *
     * GET Requests:
     *     1) getTeamById - GET By ID
     *     2) searchTeamByKeyword - GET SEARCH LIST By KEYWORD
     *     3) getTeamListByOrgId - GET LIST By ORG ID
     *     4) getTeamListByUserId - GET LIST By USER ID
     *
     * POST Requests:
     *     2) createTeam - CREATE Team
     *
     * PUT Requests:
     *     1) updateTeam - UPDATE Team
     *
     */

    async getTeamById(id) {
        try {
            let url = window.location.origin + this.TEAM + this.GET_BY_ID;
            url = url
                .replace('{id}', id)
            const teamData = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return teamData;
        } catch(err) {
            console.log(err);
        }
    }

    async searchTeamByKeyword(keyword, activeUserId) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.TEAM + this.SEARCH_TEAM_BY_KEYWORD;
            let keywordMap = {
                'keyword': keyword,
                'activeUserId': activeUserId
            }
            const teamList = this.fetch(url, {
                    method:'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken
                    },
                    body: JSON.stringify(keywordMap)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else if(data.error === 'Not Found'){
                                data.body = '[]';
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return teamList;
        } catch(err) {
            console.log(err);
        }
    }

    async searchTeamByKeywordForUser(keyword) {
        try {
            let url = window.location.origin + this.TEAM + this.SEARCH_TEAM_BY_KEYWORD_FOR_USER;
            url = url
                .replace('{keyword}', keyword);
            const teamList = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else if(data.error === 'Not Found'){
                                data.body = '[]';
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return teamList;
        } catch(err) {
            console.log(err);
        }
    }

    async getUserListByTeamId(teamId) {
        let url = window.location.origin + this.TEAM + this.GET_USER_LIST_BY_TEAM;
        url = url
            .replace('{teamId}', teamId)
        try {
            const teamDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return teamDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getTeamListByOrgId(orgId) {
        let url = window.location.origin + this.TEAM + this.GET_LIST_BY_ORG;
        url = url
            .replace('{orgId}', orgId)
        try {
            const teamDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return teamDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getTeamListByUserId(userId) {
        let url = window.location.origin + this.TEAM + this.GET_LIST_BY_USER;
        url = url
            .replace('{userId}', userId)
        try {
            const teamDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return teamDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async addContributorToTeam(addMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TEAM + this.ADD_CONTRIBUTOR;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(addMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateContributorPermissionInTeam(updateMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TEAM + this.UPDATE_CONTRIBUTOR;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async removeContributorPermissionFromTeam(removeMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TEAM + this.REMOVE_CONTRIBUTOR;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(removeMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async createTeam(team){
        let url = window.location.origin + this.TEAM;
        try{
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const teamCreated = this.fetch(url, {
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(team)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return teamCreated;
        }
        catch(err){
            console.log(err);
        }
    }

    async updateTeam(team){
        try{
            let url = window.location.origin + this.TEAM;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const teamCreated = this.fetch(url, {
                method:'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(team)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return teamCreated;
        }
        catch(err){
            console.log(err);
        }
    }

    async deleteTeam(team){
        try{
            let url = window.location.origin + this.TEAM;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const teamCreated = this.fetch(url, {
                method:'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(team)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return teamCreated;
        }
        catch(err){
            console.log(err);
        }
    }
}

export default TeamService;
